import { useState } from "react";
export const useOverflown = () => {
    const [isOverflown, setIsOverflown] = useState(false);
    const checkOverflown = ({ currentTarget: { clientWidth, scrollWidth, clientHeight, scrollHeight }, }) => {
        setIsOverflown(clientWidth >= scrollWidth && clientHeight >= scrollHeight);
    };
    return { isOverflown, checkOverflown };
};
